$(document).ready(function() {
    $(document).on('click', '.update-cart-total-btn', function(e) {
        e.preventDefault();
        const lineKey = $(this).data('line-key');
        const $quickView = $(this).closest('.halo-quickView');
        const containerId = $quickView.length ? `alpha-list-container-${$quickView.data('product-id')}` : 'alpha-list-container';
        const productHandle = $quickView.length ? $quickView.data('product-quickview-handle') : window.productHandle;
        removeLineItem(lineKey, containerId, productHandle);
    });

    $(document).on('click', '.remove-all-product', function(e) {
        e.preventDefault();
        const productId = $(this).data('product-id');
        const $quickView = $(this).closest('.halo-quickView');
        const containerId = $quickView.length ? `alpha-list-container-${productId}` : 'alpha-list-container';
        const productHandle = $quickView.length ? $quickView.data('product-quickview-handle') : window.productHandle;
        removeAllProductItems(productId, containerId, productHandle);
    });
  
    updateCartTotal();
    sortCartItems('alpha-list-container'); // Sort initial render
});

function updateCartTotal(cart) {
    console.log('cartTotalPrice exists:', !!$('#cartTotalPrice').length);
    console.log('cartTotalPrice-mb exists:', !!$('#cartTotalPrice-mb').length);
    if (cart) {
        console.log('Updating with provided cart, total_price:', cart.total_price);
        $('#cartTotalPrice, #cartTotalPrice-mb').html(Shopify.formatMoney(cart.total_price, window.money_format));
    } else {
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            dataType: 'json',
            success: function(cart) {
                console.log('Fetched cart, total_price:', cart.total_price);
                $('#cartTotalPrice, #cartTotalPrice-mb').html(Shopify.formatMoney(cart.total_price, window.money_format));
            },
            error: function() {
                console.error('Failed to update cart total');
                alert('Error updating cart total.');
            }
        });
    }
}

// Global debounce for refresh (prevents lag / race conditions on rapid adds)
let refreshTimeout = null;

async function refreshAlphaList(containerId = 'alpha-list-container', productHandle) {
    if (refreshTimeout) clearTimeout(refreshTimeout);
    
    refreshTimeout = setTimeout(async () => {
        try {
            console.log('Refreshing ALPHA-LIST (debounced):', { containerId, productHandle });
            const response = await fetch(`/products/${productHandle}?section_id=alpha-list-ajax`, {
                headers: { 'Accept': 'text/html' }
            });
            const html = await response.text();
            const container = document.getElementById(containerId);
            if (container) {
                container.innerHTML = html;
                sortCartItems(containerId);
            }
        } catch (error) {
            console.error('Error refreshing ALPHA-LIST:', error);
        }
        refreshTimeout = null;
    }, 300); // 300ms debounce — waits for Shopify cart to settle
}

async function removeAllProductItems(productId, containerId = 'alpha-list-container', productHandle) {
    try {
        const cart = await fetch('/cart.js').then(res => res.json());
        const updates = {};
        cart.items.forEach(item => {
            if (item.product_id == productId) updates[item.key] = 0;
        });
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        });
        const updatedCart = await fetch('/cart.js').then(res => res.json());
        console.log('Remove all - Updated cart:', updatedCart);
        updateCartTotal(updatedCart);
        refreshAlphaList(containerId, productHandle); // Refresh and sort
    } catch (error) {
        console.error('Error removing all items:', error);
        alert('Failed to remove items.');
    }
}

async function removeLineItem(lineKey, containerId = 'alpha-list-container', productHandle) {
    try {
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [lineKey]: 0 } })
        });
        const updatedCart = await fetch('/cart.js').then(res => res.json());
        console.log('Remove single - Updated cart:', updatedCart);
        updateCartTotal(updatedCart);

        // Check if there are still items for the product in the cart
        const hasProductItems = updatedCart.items.some(item => item.product_id == productHandle.split('/').pop());
        const container = document.getElementById(containerId);
        if (container) {
            await refreshAlphaList(containerId, productHandle);
            // Explicitly control prody-in-cart visibility
            const prodyInCart = container.querySelector('.prody-in-cart');
            if (prodyInCart) {
                prodyInCart.style.display = hasProductItems ? 'block' : 'none';
            }
        } else {
            console.error('Container not found:', containerId);
        }
    } catch (error) {
        console.error('Error removing item:', error);
        // Alert removed to prevent unnecessary user notification
        // alert('Failed to remove item.');
    }
}

function sortCartItems(containerId = 'alpha-list-container') {
    const cartList = document.querySelector(`#${containerId} .prody-in-cart ol`);
    if (!cartList) {
        console.warn('Cart list not found for sorting:', containerId);
        return;
    }
    const items = Array.from(cartList.children);
    if (items.length === 0) return;

    items.sort((a, b) => {
        const titleA = a.getAttribute('data-title') || '';
        const titleB = b.getAttribute('data-title') || '';
        const colorA = a.getAttribute('data-color') || '';
        const colorB = b.getAttribute('data-color') || '';
        
        // FIXED: correctly grabs size for BOTH normal variants AND custom properties.Size
        const sizeA = a.querySelector('.sizeTextStyles2')?.textContent.trim() || 
                      a.querySelector('.alpha-size > div')?.textContent.trim() || '';
        const sizeB = b.querySelector('.sizeTextStyles2')?.textContent.trim() || 
                      b.querySelector('.alpha-size > div')?.textContent.trim() || '';

        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        if (colorA < colorB) return -1;
        if (colorA > colorB) return 1;
        return getSizeIndex(sizeA) - getSizeIndex(sizeB);
    });

    while (cartList.firstChild) cartList.removeChild(cartList.firstChild);
    items.forEach(item => cartList.appendChild(item));
    console.log('Sorted ALPHA-LIST:', containerId);
}

function getSizeIndex(size) {
    const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'];
    return sizeOrder.indexOf((size || '').toUpperCase()) !== -1 ? sizeOrder.indexOf(size.toUpperCase()) : sizeOrder.length;
}

function initializeQuickViewAlphaList($quickView) {
    const productId = $quickView.data('product-id');
    const containerId = `alpha-list-container-${productId}`;
    const productHandle = $quickView.data('product-quickview-handle');
    console.log('Initializing Quick-View:', { containerId, productHandle });
    if (productHandle && document.getElementById(containerId)) {
        refreshAlphaList(containerId, productHandle);
    }
}

$(document).on('click', '[data-open-quick-view-popup]', function() {
    const productId = $(this).data('product-id');
    const productHandle = $(this).data('product-handle');
    setTimeout(() => {
        const $quickView = $(`.halo-quickView[data-product-id="${productId}"]`);
        if ($quickView.length) {
            $quickView.data('product-quickview-handle', productHandle);
            initializeQuickViewAlphaList($quickView);
        }
    }, 100);
});

document.addEventListener('DOMContentLoaded', () => {
    const productView = document.querySelector('.productView');
    if (productView && !productView.classList.contains('halo-quickView')) {
        window.productHandle = productView.dataset.productHandle;
        sortCartItems('alpha-list-container'); // Sort initial render
        refreshAlphaList('alpha-list-container', window.productHandle);
    }
});

// *** FIXED: LISTEN FOR THEME'S "cart:updated" EVENT + safety guard for cart page (halo-side-cart) ***
document.addEventListener('cart:updated', function() {
    const $quickView = $('.halo-quickView');
    if ($quickView.length) {
        const productId = $quickView.data('product-id');
        const containerId = `alpha-list-container-${productId}`;
        const productHandle = $quickView.data('product-quickview-handle');
        if (productId && containerId && productHandle) {
            refreshAlphaList(containerId, productHandle);
        }
    } else if (window.productHandle) {
        refreshAlphaList('alpha-list-container', window.productHandle);
    }
    // No action on cart page (halo-side-cart) → prevents JS error
});